module.exports = __webpack_public_path__ + "static/media/persona_f_20_03.44bf9324.png";